module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = stream
// module chunks = 5